export enum UserOrganizationState {
  Active = 1,
  Disabled = 2,
}
